import { createI18n } from 'vue-i18n'

export const vueI18n = (initialLocale = 'en-GB') => {
    window.messages = {}
    if (window.vuei18nLocales !== undefined) {
        Object.keys(window.vuei18nLocales).forEach(function (lang) {
            window.messages[lang] = window.vuei18nLocales[lang]
        })
    }

    return createI18n({
        legacy: true,
        locale: initialLocale,
        fallbackLocale: 'en-GB',
        messages: window.messages,
        silentTranslationWarn: true,
    })
}
